import React, {useState} from 'react'
// import datas from '../../../../datas/Datas.json'
// import JobCard from '../../../../components/Cards/JobCard'
// import TrainerCard from '../../../../components/Cards/TrainerCard'
// import TrainingCard from '../../../../trainer/components/Card/TrainingCard'
import FormationCard from '../../../../components/Cards/FormationCard'

const Offer = ({item}) => {
    const [jobs, setJobs] = useState([])
  return (
    <div className='grid grid-cols-1 gap-y-4'>
       {item?.map((job)=>{
          return( 
            <FormationCard key={job.id} item={job} />
            )
          
        })} 
    </div>
  )
}

export default Offer